import { Layout as AntLayout } from "antd";
import { ReactNode } from "react";

import { useAuth } from "../../hooks/useAuth";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const { user } = useAuth();

  if (!user || user.role === "user") {
    return <>{children}</>;
  }

  return (
    <AntLayout className="platform-shell">
      <Sidebar role={user.role} />
      <AntLayout>
        <TopBar />
        <AntLayout.Content className="platform-content">
          {children}
        </AntLayout.Content>
      </AntLayout>
    </AntLayout>
  );
};

export default AppLayout;
